export const INDEPENDENT_CONTRACTOR_BADGE_LOCATION = {
  CALENDAR_PAGE: "CALENDAR_PAGE",
  PROFESSIONAL_DETAILS: "PROFESSIONAL_DETAILS",
  PROFESSIONAL_DOCUMENTS: "PROFESSIONAL_DOCUMENTS",
} as const;

export const INDEPENDENT_CONTRACTOR_BADGE_CREATION_METHOD = {
  AUTOMATIC_SINGLE_ROLE: "AUTOMATIC_SINGLE_ROLE",
  AUTOMATIC_TARGET_MATCH: "AUTOMATIC_TARGET_MATCH",
  MODAL_SELECTION: "MODAL_SELECTION",
} as const;

// eslint-disable-next-line no-restricted-syntax
export enum IndependentContractorBadgeGeneratedBy {
  ADMIN = "ADMIN",
  WORKPLACE = "WORKPLACE",
}

export type IndependentContractorBadgeLocation =
  (typeof INDEPENDENT_CONTRACTOR_BADGE_LOCATION)[keyof typeof INDEPENDENT_CONTRACTOR_BADGE_LOCATION];

export type IndependentContractorBadgeCreationMethod =
  (typeof INDEPENDENT_CONTRACTOR_BADGE_CREATION_METHOD)[keyof typeof INDEPENDENT_CONTRACTOR_BADGE_CREATION_METHOD];

export interface IndependentContractorBadgeMeta {
  creationMethod: IndependentContractorBadgeCreationMethod;
}
